/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

export const stickyBottomBarBodyStyle = css`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  justify-content: end;
  padding: 12px 16px;
  width: 100%;
  gap: 8px;
`;
